import AbstractSystem from "../all/AbstractSystem";

class HisenseSystem extends AbstractSystem {
    
    exit() {
        window.open('/node/homeuser', '_self', '');
        window.close();
    }
}

export default HisenseSystem;



// WEBPACK FOOTER //
// ./src/devices/hisense/System.js